import { sanitizeHtml } from './utilities';
export class defaultParsers {
    paragraph(data, config) {
        return `<p class="${config.paragraph.pClass}"> ${data.text} </p>`;
    }
    header(data) {
        return `<h${data.level}>${data.text}</h${data.level}>`;
    }
    list(data) {
        const listStyle = data.style === 'unordered' ? 'ul' : 'ol';
        const recursor = (items, listStyle) => {
            const list = items.map((item) => {
                if (!item.content && !item.items) {
                    return `<li>${item}</li>`;
                }
                let list = '';
                if (item.items) {
                    list = recursor(item.items, listStyle);
                }
                if (item.content) {
                    return `<li>${item.content}${list}</li>`;
                }
            });
            return list.length > 0 ? `<${listStyle}>${list.join('')}</${listStyle}>` : ``;
        };
        return recursor(data.items, listStyle);
    }
    quote(data, config) {
        let alignment = '';
        if (config.quote.applyAlignment) {
            alignment = `style="text-align: ${data.alignment};"`;
        }
        return `<blockquote ${alignment}><p>${data.text}</p><cite>${data.caption}</cite></blockquote>`;
    }
    table(data) {
        const rows = data.content.map((row) => {
            return `<tr>${row.reduce((acc, cell) => `${acc}<td>${cell}</td>`, '')}</tr>`;
        });
        return `<table><tbody>${rows.join('')}</tbody></table>`;
    }
    image(data, config) {
        const imageConditions = `${data.stretched ? 'img-fullwidth' : ''} ${data.withBorder ? 'img-border' : ''} ${data.withBackground ? 'img-bg' : ''}`;
        const imgClass = config.image.imgClass || '';
        let imageSrc;
        if (data.url) {
            // simple-image was used and the image probably is not uploaded to this server
            // therefore, we use the absolute path provided in data.url
            // so, config.image.path property is useless in this case!
            imageSrc = data.url;
        }
        else if (config.image.path === 'absolute') {
            imageSrc = data.file.url;
        }
        else {
            imageSrc = config.image.path.replace(/<(.+)>/, (match, p1) => data.file[p1]);
        }
        if (config.image.use === 'img') {
            return `<img class="${imageConditions} ${imgClass}" src="${imageSrc}" alt="${data.caption}">`;
        }
        if (config.image.use === 'figure') {
            const figureClass = config.image.figureClass || '';
            const figCapClass = config.image.figCapClass || '';
            return `<figure class="${figureClass}"><img class="${imgClass} ${imageConditions}" src="${imageSrc}" alt="${data.caption}"><figcaption class="${figCapClass}">${data.caption}</figcaption></figure>`;
        }
    }
    code(data, config) {
        const markup = sanitizeHtml(data.code);
        return `<pre><code class="${config.code.codeBlockClass}">${markup}</code></pre>`;
    }
    raw(data) {
        return data.html;
    }
    delimiter() {
        return '<br />';
    }
    embed(data, config) {
        if (config.embed.useProvidedLength) {
            data.length = `width="${data.width}" height="${data.height}"`;
        }
        else {
            data.length = '';
        }
        const regex = new RegExp(/<%data\.(.+?)%>/, 'gm');
        return config.embedMarkups[data.service]
            ? config.embedMarkups[data.service].replace(regex, (match, p1) => data[p1])
            : config.embedMarkups['defaultMarkup'].replace(regex, (match, p1) => data[p1]);
    }
}
export const DefaultParsers = new defaultParsers();
//# sourceMappingURL=defaultParsers.js.map